import { useState } from "react";

import { LoyaltyMessageEditForm } from "src/app/features/LoyaltyMessage/components/forms/LoyaltyMessageEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";

export const LoyaltyMessageEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.LOYALTY_MESSAGES, "canWrite");
    const hasAccess = canAccess(ResourceName.LOYALTY_MESSAGES, "canRead");

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.loyaltyMessageEditFormPage" />
                        <ActionBar>
                            <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                            <RefreshButton isDisabled={false} />
                        </ActionBar>
                    </FPageHeader>
                    <FPageContent>
                        <LoyaltyMessageEditForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
